const en = {
    common: {
        appName: 'Ipsum City',
        productName: 'Asset & Fault Management System',
        home: 'Home',
        back: 'Back',
        item: 'item',
        items: 'items',
        user: 'user',
        users: 'users',
        card: 'card',
        cards: 'cards',
        task: 'task',
        tasks: 'tasks',
        language: 'Language',
        save: 'Save',
        cancel: 'Cancel',
        search: 'Search',
        clear: 'Clear',
        details: 'Details',
        edit: 'Edit',
        english: 'English',
        lithuanian: 'Lithuanian',
        reset: 'Reset',
        loading: 'Loading…',
        moreFilters: 'More filters',
        from: 'From',
        to: 'To',
        rows: 'Rows',
        address: 'Address',
        description: 'Description',
        contractor: 'Contractor',
        classification: 'Classification',
        district: 'District',
        category: 'Category',
        subcategory: 'Subcategory',
        location: 'Location',
        date: 'Date',
        type: 'Type',
        status: 'Status',
        total: 'Total',
        today: 'today',
        map: 'Map',
        enlarge: 'Enlarge',
        close: 'Close',
        fullscreen: 'Fullscreen',
        exit: 'Exit',
        appearance: 'Appearance',
        created: 'Created',
        completed: 'Completed',
        select: 'Select…',
        equipment: 'Equipment',
        export: 'Export',
        importCsv: 'Import CSV',
        importing: 'Importing...',
        browse: 'Browse',
        addNote: 'Add Note',
        document: 'document',
        documents: 'documents',
        unknownUser: 'Unknown user',
        entry: 'entry',
        entries: 'entries',
        required: 'Required',
        invalidEmail: 'Invalid Email Address',
        invalidPassword: 'Invalid Password',
        passwordMin: 'Password must be at least 8 characters',
        passwordMatch: 'Password Confirmation must match',
        record: 'record',
        records: 'records',
        site: 'Site'
    },
    status: {
        created: 'Created',
        accepted: 'Accepted',
        started: 'Started',
        wip: 'WIP',
        completed: 'Completed',
        urgent: 'Urgent'
    },
    display: {
        light: 'Light',
        dark: 'Dark',
        wall: 'Wall',
        wallTitle: 'Wall mode for large screens'
    },
    time: {
        minutesShort: '{{n}} min',
        hoursShort: '{{n}} hrs',
        daysShort: '{{n}} days'
    },
    nav: {
        dashboard: 'Dashboard',
        tasks: 'Tasks',
        addTask: 'Add Task',
        actives: 'Actives',
        completed: 'Completed',
        taskBoard: 'Task Board',
        assets: 'Assets',
        assetLocator: 'Asset Locator',
        costs: 'Costs',
        preliminaries: 'Preliminaries',
        costManager: 'Cost Manager',
        inventory: 'Inventory',
        reports: 'Reports',
        monthlyReport: 'Monthly Report',
        kpis: "KPI's",
        users: 'Users',
        addUser: 'Add User',
        logout: 'Logout',
        openMenu: 'Open menu',
        closeMenu: 'Close menu',
        expandMenu: 'Expand menu',
        collapseMenu: 'Collapse menu',
        main: 'Main'
    },
    login: {
        brandSubtitle: 'Sign in to access your dashboard',
        title: 'Sign in',
        subtitle: 'Enter your credentials to continue',
        email: 'Email',
        password: 'Password',
        emailPlaceholder: 'name@example.com',
        passwordPlaceholder: 'Your password',
        showPassword: 'Show password',
        hidePassword: 'Hide password',
        submit: 'Sign in',
        submitting: 'Signing in…',
        confirmEmail: 'Confirm email',
        forgotPassword: 'Forgot password?',
        emailRequired: 'Enter your email.',
        emailInvalid: 'Enter a valid email address.',
        passwordRequired: 'Enter your password.',
        mfaSetupTitle: 'Set up authenticator',
        mfaVerifyTitle: 'Two-step verification',
        mfaHintOptional: 'Optional: scan the QR code with your authenticator app, then enter the 6-digit code. You can skip and set this up later.',
        mfaHintSetup: 'Two-step verification is required. Scan the QR code with your authenticator app, then enter the 6-digit code.',
        mfaHintSms: 'Enter the code sent by SMS.',
        mfaHintApp: 'Enter the code from your authenticator app.',
        mfaPreparing: 'Preparing QR code…',
        mfaSecretHint: 'If you cannot scan the code, add an account manually and enter this secret:',
        authenticatorCode: 'Authenticator code',
        verificationCode: 'Verification code',
        completeSetup: 'Complete setup',
        verify: 'Verify',
        saving: 'Saving…',
        verifying: 'Verifying…',
        skipForNow: 'Skip for now',
        backToLogin: 'Back to login',
        confirmEmailTitle: 'Confirm Email',
        confirmEmailHint: 'Enter your email and the confirmation code we sent you.',
        confirmationCode: 'Confirmation Code',
        enterCode: 'Enter code',
        checkEmailCode: 'Please check your email for the code.',
        confirm: 'Confirm',
        resetPasswordTitle: 'Reset Password',
        resetPasswordHint: 'Enter your email, the reset code and your new password.',
        resetCode: 'Reset Code',
        askAdminCode: 'Please ask the Administrator for the code.',
        newPassword: 'New Password',
        newPasswordPlaceholder: 'New password',
        resetPassword: 'Reset Password',
        crestAlt: 'Crest'
    },
    pages: {
        dashboard: {
            title: 'Dashboard',
            subtitle: 'Overview of tasks, faults, and assets'
        },
        kpis: {
            title: 'Key Performance Indicators',
            subtitle: 'Service, maintenance, SLA and spend for the selected period',
            crumb: "KPI's"
        },
        tasksActive: {
            title: 'Tasks Active',
            subtitle: 'Manage and monitor active tasks'
        },
        tasksCompleted: {
            title: 'Tasks Completed',
            subtitle: 'Completed and closed tasks'
        },
        taskBoard: {
            title: 'Task Board',
            subtitle: 'Work in progress across today',
            crumb: 'Board'
        },
        taskDetails: {
            title: 'Task Details',
            pageTitle: 'Task {{ref}}'
        },
        taskAdd: {
            newTitle: 'New Task',
            editTitle: 'Edit Task',
            newSubtitle: 'Create a new task',
            editSubtitle: 'Update task details',
            backToDetails: 'Task Details'
        },
        assets: {
            title: 'Assets',
            subtitle: 'Sites and equipment'
        },
        assetLocator: {
            title: 'Asset Locator',
            subtitle: 'Find and manage infrastructure assets',
            crumb: 'Locator',
            bridgeTitle: 'Bridge Devices Map',
            bridgeCrumb: 'Bridge Devices'
        },
        assetDetails: {
            title: 'Asset Details',
            pageTitle: 'Asset {{ref}}',
            highPriority: 'High priority',
            lowPriority: 'Low priority'
        },
        assetAdd: {
            newTitle: 'New Asset',
            editTitle: 'Edit Asset'
        },
        costManager: {
            title: 'Cost Manager',
            subtitle: 'Task costs, materials and labour'
        },
        preliminaries: {
            title: 'Preliminaries',
            subtitle: 'Standing charges and other preliminary costs'
        },
        inventory: {
            title: 'Inventory',
            subtitle: 'Stock items and rates'
        },
        monthlyReport: {
            title: 'Monthly Report',
            subtitle: 'Completed and WIP tasks for the selected period'
        },
        users: {
            title: 'Users'
        },
        addUser: {
            title: 'Add User'
        },
        editUser: {
            title: 'Edit User',
            user: 'User',
            subtitle: 'Manage user information and access permissions'
        }
    },
    dashboard: {
        operationsOverview: 'Operations overview',
        live: 'LIVE',
        waiting: 'WAITING',
        stale: 'STALE',
        connectionLost: 'CONNECTION LOST',
        updated: 'Updated',
        time: 'Time',
        monitoredSites: 'Monitored sites',
        mapTasks: 'Map tasks',
        exitWall: 'Exit wall mode',
        tasksActive: 'Tasks Active',
        tasksCompleted: 'Tasks Completed',
        workInProgress: 'Work In Progress',
        taskOutstanding: 'Task Outstanding',
        last7days: 'Last 7 days',
        last30days: 'Last 30 days',
        activeLast7: 'Active · last 7 days',
        completedLast7: 'Completed · last 7 days',
        currentlyInProgress: 'Currently in progress',
        openOver7days: 'Open > 7 days',
        createdToday: 'created today',
        completedToday: 'completed today',
        inProgressToday: 'in progress today',
        overdueCount: '{{count}} overdue',
        oldestDays: 'oldest {{days}}d',
        taskMap: 'Task Map',
        liveTaskMap: 'Live task map',
        fitSites: 'Fit sites',
        fitSitesTitle: 'Centre on monitored sites',
        overview: 'Overview',
        overviewTitle: 'Council overview',
        filterMarkers: 'Filter markers by status',
        closeMap: 'Close map',
        enlargeMap: 'Enlarge map',
        incidents: 'Incidents',
        urgentFaults: 'Urgent Faults',
        faultReports: 'Fault Reports',
        detectionDamage: 'Detection Damage',
        urgentReactive: 'Urgent reactive',
        allReactive: 'All reactive tasks',
        detectorIssues: 'Detector / loop issues · all open reports',
        countToday: '{{count}} today',
        countOpen: '{{count}} open',
        countUnassigned: '{{count}} unassigned',
        countOpenOver7: '{{count}} open > 7 days',
        recentFaults: 'Recent Faults',
        upcomingInspections: 'Upcoming Inspections',
        viewAll: 'View all',
        noRecords: 'No records in the last 30 days',
        analyticsTitle: 'Service Calls & SLA Analytics',
        analyticsSubtitle: 'Context for the last 30 days',
        serviceCalls: 'Service Calls',
        serviceCallsReactive: 'Service Calls - Reactive Maintenance',
        serviceCallsPpm: 'Service Calls - Preventative Maintenance',
        slaAttendance: 'SLA Attendance',
        slaComplete: 'SLA Complete Tasks',
        compliance: 'Compliance',
        nonCompliance: 'Non Compliance',
        chartReactive: 'Reactive',
        chartPpmInspections: 'PPM Inspections',
        chartPpmRoutine: 'PPM Routine Maint',
        modalFaultReport: 'Fault Report',
        modalUrgentFault: 'Urgent Fault',
        modalLoopDamage: 'Loop/Detection Damage',
        alertUrgentAgedOne: '{{count}} urgent fault has been open more than 7 days',
        alertUrgentAgedMany: '{{count}} urgent faults have been open more than 7 days',
        alertSlaOne: '{{count}} task is past SLA attend',
        alertSlaMany: '{{count}} tasks are past SLA attend',
        alertUnassignedOne: '{{count}} urgent fault is unassigned',
        alertUnassignedMany: '{{count}} urgent faults are unassigned',
        showPin: 'Show {{label}}',
        hidePin: 'Hide {{label}}'
    },
    tasks: {
        addTask: 'Add Task',
        openTask: 'Open task',
        allTasks: 'All tasks',
        recentlyCreated: 'Recently created',
        assignedToMe: 'Assigned to me',
        sort: 'Sort',
        newestCreated: 'Newest created',
        oldestCreated: 'Oldest created',
        urgency: 'Urgency',
        slaAttend: 'SLA attend',
        slaRepair: 'SLA repair',
        slaAttendValue: 'SLA attend {{contract}}',
        searchPlaceholder: 'Search by reference, site, address or description',
        taskRef: 'Task ref',
        siteRef: 'Site ref',
        createdFrom: 'Created from',
        createdTo: 'Created to',
        completedFrom: 'Completed from',
        completedTo: 'Completed to',
        loading: 'Loading tasks...',
        emptyActive: 'No active tasks match these filters.',
        emptyCompleted: 'No completed tasks match these filters.',
        showing: 'Showing {{start}}–{{end}} of {{total}} tasks',
        legendActive: 'TASK · STATUS · SITE · DISTRICT · CATEGORY · CREATED',
        legendCompleted: 'TASK · STATUS · SITE · DISTRICT · CATEGORY · COMPLETED',
        noDescription: 'No description',
        expand: 'Expand task',
        collapse: 'Collapse task',
        overdueBy: '{{duration}} overdue',
        timeLeft: '{{duration}} left',
        quickFilters: 'Quick filters'
    },
    months: {
        january: 'January',
        february: 'February',
        march: 'March',
        april: 'April',
        may: 'May',
        june: 'June',
        july: 'July',
        august: 'August',
        september: 'September',
        october: 'October',
        november: 'November',
        december: 'December'
    },
    fields: {
        siteRef: 'Site Ref',
        siteAddress: 'Site Address',
        siteLocation: 'Site Location',
        siteReference: 'Site Reference',
        assetType: 'Asset Type',
        prioritySite: 'Priority Site',
        chargeCode: 'Charge Code',
        controller: 'Controller',
        signalHead: 'Signal Head',
        halogenLed: 'Halogen/LED',
        pushButton: 'Push Button',
        elvLv: 'ELV/LV',
        operatingMode: 'Operating Mode',
        tmrpn: 'TMRPN Nr',
        powerConsumption: 'Power Consumption (Amps/W)',
        billedConsumption: 'Billed Consumption (W)',
        installationDate: 'Installation Date',
        upgradeDate: 'Upgrade Date',
        supplySource: 'Supply Source',
        specialCondition: 'Special Condition',
        makeModel: 'Make / Model',
        signDisplay: 'Sign Display',
        installedBy: 'Installed By',
        additionalInfo: 'Additional Information',
        schoolName: 'School Name',
        phoneNumber: 'Phone Number',
        schoolTimes: 'School Times',
        signSwitchOn: 'Sign Switch on',
        signSwitchOff: 'Sign Switch off',
        controllerLink: 'Controller Link',
        cameraLink: 'Camera Link',
        latitude: 'Latitude',
        longitude: 'Longitude',
        categoryOfWork: 'Category of Work',
        subCategory: 'Sub Category',
        slaToAttend: 'SLA to Attend',
        slaToComplete: 'SLA to Complete',
        slaComplete: 'SLA complete',
        chargeable: 'Chargeable',
        contractorRef: 'Contractor Ref',
        jobNumber: 'Job Number',
        invoiceDate: 'Invoice Date',
        invoiceNumber: 'Invoice Number',
        workRequired: 'Work Required',
        contractorDetails: 'Contractor Details',
        siteDetails: 'Site Details',
        equipmentDetails: 'Equipment Details',
        technicalInfo: 'Technical Information',
        schoolDetails: 'School Details',
        taskInformation: 'Task information',
        materials: 'Materials',
        callOutFee: 'Call Out Fee',
        onSiteLabour: 'On Site Labour',
        totalCost: 'Total Cost',
        materialsTotal: 'Materials Total',
        searchMaterial: 'Search Material',
        qty: 'Qty',
        rate: 'Rate',
        subtotal: 'Subtotal',
        itemId: 'Item ID',
        nr: 'Nr',
        note: 'Note',
        image: 'Image',
        file: 'File',
        filename: 'Filename',
        version: 'Version',
        lastUpdate: 'Last update',
        name: 'Name',
        email: 'Email',
        admin: 'Admin',
        administrator: 'Administrator',
        enabled: 'Enabled',
        disabled: 'Disabled',
        verified: 'Verified',
        updated: 'Updated',
        confirmPassword: 'Confirm Password',
        applicationAccess: 'Application Access',
        routineInspection: 'Routine Inspection',
        problem: 'Problem',
        na: 'N/A',
        scheduled: 'Scheduled',
        fixed: 'Fixed',
        quoted: 'Quoted',
        reference: 'Reference',
        amount: 'Amount',
        calculatedTotal: 'Calculated total',
        workCarriedOut: 'Work carried out',
        callOut: 'Call-out',
        gpsCoordinates: 'GPS Coordinates',
        remoteAccess: 'Remote Access',
        supplyGps: 'Supply GPS Coordinates',
        siteAndPriority: 'Site & Priority',
        workClassificationSla: 'Work Classification & SLA',
        docNo: 'Doc No.'
    },
    actions: {
        add: 'Add',
        addAsset: 'Add Asset',
        addUser: 'Add User',
        addItem: 'Add Item',
        addCost: 'Add Cost',
        addCard: 'Add card',
        addList: 'Add List',
        addLane: 'Add',
        openAsset: 'Open asset',
        editTask: 'Edit task',
        complete: 'Complete',
        moveToWip: 'Move to WIP',
        moveToCompleted: 'Move to Completed',
        completing: 'Completing…',
        delete: 'Delete',
        save: 'Save',
        clear: 'Clear',
        copy: 'Copy',
        viewQr: 'View QR',
        download: 'Download',
        apply: 'Search',
        filters: 'Filters',
        notes: 'Notes',
        documents: 'Documents',
        details: 'Details',
        camera: 'Camera',
        googleMaps: 'Google Maps'
    },
    assets: {
        countLabel: 'assets',
        searchPlaceholder: 'Search by site, address, type or charge code',
        loading: 'Loading assets...',
        empty: 'No assets match these filters.',
        showing: 'Showing {{start}}–{{end}} of {{total}} assets',
        legend: 'SITE · TYPE · ADDRESS · DISTRICT · CONTROLLER · HEADS',
        noAddress: 'No address',
        priority: 'Priority',
        prioritySite: 'Priority site',
        expand: 'Expand asset',
        collapse: 'Collapse asset',
        deleteTitle: 'Delete Asset',
        deleteConfirm: 'Please confirm that you really want to delete this asset',
        deleted: 'Asset Deleted',
        deleteError: 'Error Deleting Asset',
        loadingAsset: 'Loading asset…',
        noGps: 'No GPS coordinates',
        noGpsHint: 'This asset does not have a mapped location yet.',
        qrTitle: 'Asset QR',
        high: 'High',
        low: 'Low',
        noTasks: 'No tasks for this asset yet.'
    },
    locator: {
        filters: 'Filters',
        allDistricts: 'All districts',
        allTypes: 'All types',
        allSigns: 'All Signs',
        highPriority: 'High priority',
        noMapLocation: 'No map location',
        mapLegend: 'Map legend',
        assetTypes: 'Asset types',
        showLess: 'Show less',
        showAll: 'Show all',
        loading: 'Loading assets...',
        pleaseWait: 'Please wait while we fetch your data',
        retryLater: 'Refresh the page or try again later',
        results: '{{count}} results',
        sortBy: 'Sort by',
        siteAz: 'Site ref A-Z',
        siteZa: 'Site ref Z-A',
        sortType: 'Asset type',
        noRecords: 'No records found',
        tryFilters: 'Try adjusting the filters',
        openAsset: 'Open {{ref}}',
        resizeList: 'Resize asset list',
        showList: 'Show asset list',
        expandMap: 'Expand map',
        other: 'Other'
    },
    kpis: {
        year: 'Year',
        month: 'Month',
        serviceCalls: 'Service calls',
        pendingHint: '{{count}} pending',
        noCreated: 'No created tasks',
        ofCreated: '{{pct}} of created',
        slaAttendance: 'SLA attendance',
        slaCompletion: 'SLA completion',
        slaOnTimeHint: '{{ok}} of {{total}} completed tasks on time',
        noSla: 'No completed tasks with SLA',
        annualSpend: 'Annual spend',
        yearToDate: '{{year}} year to date',
        createdVsCompleted: 'Created vs completed',
        created: 'Created',
        done: 'Done',
        pending: 'Pending',
        maintenance: 'Maintenance',
        maintenanceNote: 'Reactive {{reactive}} calls · PPM {{created}} created, {{completed}} completed, {{pending}} pending',
        reactiveByFault: 'Reactive by fault',
        sortedByVolume: 'Sorted by volume',
        preventative: 'Preventative maintenance',
        inspectionsRoutine: 'Inspections and routine work',
        fault: 'Fault',
        slaPerformance: 'SLA performance',
        slaNote: 'Rates use tasks completed in {{month}} that already have attendance or repair timestamps.',
        onTime: 'On time',
        late: 'Late',
        rate: 'Rate',
        spendTitle: 'Spend {{year}}',
        breakdown: 'Breakdown'
    },
    users: {
        addUser: 'Add User',
        search: 'Search…',
        clearFilters: 'Clear all filters',
        noRecords: 'No records found',
        tryFilters: 'Try adjusting or clearing the filters above',
        loading: 'Loading users...',
        pleaseWait: 'Please wait while we fetch your data',
        yes: 'Yes',
        no: 'No',
        emailVerified: 'Email verified',
        clickVerify: 'Click to verify email',
        validPassword: 'Please provide a valid Password',
        confirmEmail: 'Confirm Email',
        verifyEmail: 'Verify Email',
        emailIsVerified: 'Email is verified',
        emailVerifiedBtn: 'Email Verified',
        disableUser: 'Disable User',
        enableUser: 'Enable User',
        markVerified: 'Mark email as verified',
        pwdAtLeast: 'at least 8 characters',
        pwdCase: 'combination of upper and lower-case characters',
        pwdNumber: 'at least one number',
        pwdSpecial: 'at least one special character',
        createSubtitle: 'Create a new user account with access permissions'
    },
    costsUi: {
        addCost: 'Add Cost',
        enterDescription: 'Enter description…',
        costEuro: 'Cost (€)',
        noCosts: 'No costs found',
        addHint: 'Add a preliminary cost using the form above',
        loading: 'Loading costs...',
        pleaseWait: 'Please wait while we fetch your data',
        deleteTitle: 'Delete Cost',
        addItem: 'Add Item',
        itemIdOptional: 'Item ID (optional)',
        autoId: 'Auto-generated if empty',
        itemDescription: 'Item description',
        rateEuro: 'Rate (€)',
        materialsList: 'Materials List',
        searchItems: 'Search by Item ID or description…',
        loadingInv: 'Loading inventory...',
        noItems: 'No inventory items',
        trySearch: 'Try adjusting or clearing your search',
        addOrImport: 'Add an item above or import a CSV file',
        updatedAt: 'Updated At',
        actions: 'Actions',
        editItem: 'Edit Inventory Item',
        deleteItem: 'Delete Inventory Item',
        importReport: 'Inventory Import Report',
        totalRows: 'Total rows',
        processed: 'Processed',
        skipped: 'Skipped',
        overwritten: 'Overwritten',
        duplicates: 'Duplicates in file',
        row: 'Row',
        reason: 'Reason',
        deleteConfirm: 'Please confirm that you want to delete this cost:',
        importingFile: 'Importing file and updating materials...',
        csvColumns: 'CSV columns: Item ID, Description, Rate',
        rateHint: 'Rate accepts 12.50, 1,200.00, 1.200,00 or values with € / $ symbols.',
        showingSorted: 'Showing {{shown}} of {{total}} item(s), sorted by Item ID',
        deleteConfirmItem: 'Please confirm delete:',
        rowsFailed: 'These rows could not be added:',
        allProcessed: 'All valid rows were processed. Overwritten rows are not listed because they were updated successfully.',
        clearSearch: 'Clear search',
        enterAmount: 'Enter amount',
        edited: 'Edited',
        totalCosts: 'Total costs',
        restoreValues: 'Restore saved values for this task'
    },
    board: {
        addList: 'Add List',
        addCard: 'Add card',
        archiveList: 'Archive List',
        listName: 'List name',
        needsAttention: 'What needs attention',
        chooseTask: 'Choose task',
        colour: 'Colour',
        dragHint: 'Drag the column to reorder',
        deleteList: 'Delete list',
        noCards: 'No cards in this list',
        addLane: 'Add',
        rename: 'Rename',
        editNote: 'Edit note'
    },
    report: {
        loadingCosts: 'Loading costs…',
        loading: 'Loading report...',
        empty: 'No tasks match these filters. Adjust them and click Search.',
        exportFilter: 'Export filter',
        invoiced: 'Invoiced',
        notInvoiced: 'Not Invoiced',
        completedWip: 'Completed + WIP'
    },
    taskForm: {
        save: 'Save',
        searchMaterial: 'Search by Item ID or description',
        noMaterials: 'No materials selected',
        problemDescription: 'Problem description (if any)'
    },
    taskView: {
        deleteTitle: 'Delete Task',
        deleteConfirm: 'Please confirm that you really want to delete this task',
        wipTitle: 'Move Task to WIP',
        wipHint: 'Please provide a reason for moving this completed task back to Work In Progress:',
        wipPlaceholder: 'Enter reason for moving task to WIP...',
        completeTitle: 'Move Task to Completed',
        completeHint: 'Enter work done details. Routine inspection will be saved as all OK.',
        completePlaceholder: 'e.g. closed by Admin',
        siteHistory: 'Site history',
        noHistory: 'No history yet',
        noHistoryHint: 'Notes added to this site will appear here',
        invoice: 'Invoice',
        taskCompleted: 'Task completed',
        taskStarted: 'Task started',
        taskAccepted: 'Task accepted',
        workDone: 'Work done',
        inspectionIssue: 'Inspection issue',
        faultReported: 'Fault reported',
        movedToWip: 'Moved to WIP'
    },
    docs: {
        upload: 'Upload document',
        deleteTitle: 'Delete Document',
        deleteConfirm: 'Please confirm that you really want to delete the document number {{n}}',
        editTitle: 'Edit Document',
        doc: 'Doc',
        none: 'No documents uploaded for this asset.',
        invalidFile: 'Invalid file'
    },
    toast: {
        coordsCopied: 'Coordinates copied',
        coordsCopyFail: 'Could not copy coordinates',
        assetSaved: 'Asset Saved',
        errorSavingAsset: 'Error Saving Asset',
        errorLoadingInventory: 'Error loading inventory',
        errorLoadingAssets: 'Error loading assets',
        taskSaved: 'Task Saved',
        errorSavingTask: 'Error Saving Task',
        totalCostZero: 'The total cost is Zero (0)',
        documentSaved: 'Document Saved',
        errorSavingDocument: 'Error Saving Document',
        documentDeleted: 'Document Deleted',
        errorDeletingDocument: 'Error Deleting Document',
        errorEditingDocument: 'Error Editing Document',
        errorLoadingTasks: 'Error loading tasks',
        errorLoadingUsers: 'Error loading users',
        noteSaved: 'Note Saved',
        errorSavingNote: 'Error Saving Note',
        costSaved: 'Cost Saved',
        errorSavingCost: 'Error Saving Cost',
        costDeleted: 'Cost Deleted',
        errorDeletingCost: 'Error Deleting Cost',
        descriptionRequired: 'Description is required',
        rateMustBeNumber: 'Rate must be a number',
        inventoryAdded: 'Inventory item added',
        errorAddingInventory: 'Error adding inventory item',
        inventoryUpdated: 'Inventory item updated',
        errorUpdatingInventory: 'Error updating inventory item',
        inventoryDeleted: 'Inventory item deleted',
        errorDeletingInventory: 'Error deleting inventory item ({{id}})',
        importFinished: 'Import finished: {{n}} item(s) processed',
        errorImportingCsv: 'Error importing CSV',
        errorSavingBoard: 'Error Saving Board',
        userExists: 'User already exist',
        userCreatedUnverified: 'User created, but email could not be verified',
        userSaved: 'User Saved',
        errorSavingUser: 'Error Saving User',
        userDisabled: 'User disabled',
        errorDisablingUser: 'Error disabling user',
        userEnabled: 'User enabled',
        errorEnablingUser: 'Error enabling user',
        emailVerified: 'Email verified',
        errorVerifyingEmail: 'Error verifying email',
        passwordResetSent: 'Password Reset Code sent',
        emailVerifiedFor: 'Email verified for {{user}}',
        errorLoadingTask: 'Error loading task',
        taskNotLoaded: 'Task data not loaded',
        onlyCompletedToWip: 'Only completed tasks can be moved to WIP',
        wipReasonRequired: 'Please provide a reason for moving task to WIP',
        taskMovedToWip: 'Task moved to WIP',
        errorMovingToWip: 'Error moving task to WIP',
        noCurrentUser: 'Unable to get current user',
        onlyAdminsComplete: 'Only admins can move tasks to completed',
        onlyActiveToCompleted: 'Only active tasks can be moved to completed',
        workDoneRequired: 'Please provide work done details',
        taskMovedToCompleted: 'Task moved to Completed',
        errorMovingToCompleted: 'Error moving task to Completed',
        errorDeletingTaskLog: 'Error Deleting Task Log',
        taskDeleted: 'Task Deleted',
        errorDeletingTask: 'Error Deleting Task'
    },
    modal: {
        lastUpdate: 'Last Update',
        viewDetails: 'View details'
    },
    exportDoc: {
        pdf: 'PDF',
        exportExcel: 'Export to Excel',
        monthlyReport: 'Monthly Report',
        dateFrom: 'Date From',
        to: 'to',
        none: 'None',
        taskRef: 'Task Ref',
        municipalDistrict: 'Municipal District',
        dateCreated: 'Date Created',
        user: 'User',
        contractRequirements: 'Contract Requirements',
        slaAttendSite: 'SLA Attend Site',
        slaCompleteTask: 'SLA Complete Task',
        engineer: 'Engineer',
        taskStatus: 'Task Status',
        dateAccepted: 'Date Accepted',
        dateStarted: 'Date Started',
        dateCompleted: 'Date Completed',
        attendSite: 'Attend Site',
        completeTask: 'Complete Task',
        typeFault: 'Type Fault',
        faultDescription: 'Fault Description',
        number: 'Number',
        onSiteLabourCost: 'On Site Labour Cost',
        dayTime: '{{n}} day, {{time}}',
        daysTime: '{{n}} days, {{time}}',
        detailsOfWorks: 'Details of Works Required',
        costs: 'Costs',
        progress: 'Progress',
        costCode: 'Cost Code',
        contractorJobRef: 'Contractor Job Reference',
        descriptionOfFault: 'Description of Fault',
        descriptionOfWork: 'Description of Work Carried Out',
        typeOfFault: 'Type of Fault',
        callOutNo: 'CallOut No',
        callOutRate: 'CallOut Rate',
        callOutSubtotal: 'CallOut Subtotal',
        onsiteNo: 'Onsite No',
        onSiteRate: 'OnSite Rate',
        onSiteSubtotal: 'OnSite Subtotal',
        dateContractorAttended: 'Date Contractor Attended',
        hpSite: 'HP Site',
        urgent: 'Urgent',
        slaAttend: 'SLA Attend'
    },
    notFound: {
        title: 'Page not found',
        message: 'Sorry, page not found!',
        hint: 'The page you are looking for does not exist or may have been moved.',
        goBack: 'Go back'
    },
    ri: {
        lampsFault: 'Lamps fault',
        signalHeads: 'Signals head alignment fixing',
        poleCaps: 'Pole caps and bungs',
        pushButtons: 'Push buttons',
        controllers: 'Controllers',
        detection: 'All detection is operational',
        logBook: 'Log book',
        siteIssues: 'Site issues',
        doorClosed: 'Door closed'
    },
    catalog: {
        'Fibre Optic': 'Fibre Optic',
        'Pedestrian Crossing': 'Pedestrian Crossing',
        'Pelican Crossing': 'Pelican Crossing',
        'School Warning Sign': 'School Warning Sign',
        'Signalised Junction': 'Signalised Junction',
        'Toucan Crossing': 'Toucan Crossing',
        'Zebra Crossing': 'Zebra Crossing',
        'Sign - Other': 'Sign - Other',
        'CCTV': 'CCTV',
        'Design & Construction': 'Design & Construction',
        'Periodic Speed Limit Sign': 'Periodic Speed Limit Sign',
        'Public Lighting': 'Public Lighting',
        'Other': 'Other',
        'Puffin Crossing': 'Puffin Crossing',
        'Driver Feedback Sign': 'Driver Feedback Sign',
        'Electronic Speed Warning Sign': 'Electronic Speed Warning Sign',
        'Reactive': 'Reactive',
        'Reactive Maintenance': 'Reactive Maintenance',
        'PPM': 'PPM',
        'Planned Preventative Maintenance (PPM)': 'Planned Preventative Maintenance (PPM)',
        'Switch off / on': 'Switch off / on',
        'Switch off/on': 'Switch off/on',
        'Upgrade': 'Upgrade',
        'Upgrades': 'Upgrades',
        'Signs': 'Signs',
        'Projects': 'Projects',
        'Technical Support': 'Technical Support',
        'Inspection Request': 'Inspection Request',
        'Urgent': 'Urgent',
        'Non-Urgent': 'Non-Urgent',
        'Scheduled': 'Scheduled',
        'Fixed': 'Fixed',
        'Quoted': 'Quoted',
        'Chargeable': 'Chargeable',
        'hrs': 'hrs',
        'days': 'days',
        'Controller Fault': 'Controller Fault',
        'Detector Fault': 'Detector Fault',
        'PBU Fault': 'PBU Fault',
        'Electrical Fault': 'Electrical Fault',
        'Lamp Fault': 'Lamp Fault',
        'Comms Fault': 'Comms Fault',
        'Sign Fault': 'Sign Fault',
        'Knockdown': 'Knockdown',
        'Twisted Head': 'Twisted Head',
        'Graffiti': 'Graffiti',
        'Check Operation and Detection': 'Check Operation and Detection',
        'Lights Out': 'Lights Out',
        'Vandalism': 'Vandalism',
        'ESB power Cut': 'ESB power Cut',
        'Vehicle strike': 'Vehicle strike',
        'Twisted signal head': 'Twisted signal head',
        'Periodic Inspection': 'Periodic Inspection',
        'Periodic Inspection Report': 'Periodic Inspection Report',
        'Annual Inspection (Signals)': 'Annual Inspection (Signals)',
        'Annual Inspection (Structures)': 'Annual Inspection (Structures)',
        'Annual Inspection (Signs)': 'Annual Inspection (Signs)',
        'Annual Inspection Report': 'Annual Inspection Report',
        'Routine Maintenance': 'Routine Maintenance',
        'Non LED Lamp replacement': 'Non LED Lamp replacement',
        'Utility Contractor': 'Utility Contractor',
        'Resurfacing contractor': 'Resurfacing contractor',
        'N/A': 'N/A',
        'Refurbishment': 'Refurbishment',
        'New installation': 'New installation',
        'Works Order': 'Works Order',
        'Design Review': 'Design Review',
        'Contract Document Review': 'Contract Document Review',
        'Preliminary Design': 'Preliminary Design',
        'Detailed Design': 'Detailed Design',
        'Material Approval': 'Material Approval',
        'Site Inspection': 'Site Inspection',
        'Technical Report': 'Technical Report',
        'Techical Advice': 'Technical Advice',
        'Snagging': 'Snagging',
        'Correspondance': 'Correspondence',
        'Pre Connection Snag': 'Pre Connection Snag',
        'Post Connection Snag': 'Post Connection Snag',
        'Technical advice': 'Technical advice',
        'SCATs': 'SCATs',
        'Comms': 'Comms',
        'Lighting Design': 'Lighting Design',
        'Inspection': 'Inspection',
        'Periodic Insp': 'Periodic Insp',
        'Annual Insp (Sig)': 'Annual Insp (Sig)',
        'Annual Insp (Struc)': 'Annual Insp (Struc)',
        'Annual Insp (Signs)': 'Annual Insp (Signs)',
        'Routine Maint': 'Routine Maint',
        'Non LED Lamp rep': 'Non LED Lamp rep',
        'Non-LED Lamp': 'Non-LED Lamp',
        'PPM Inspections': 'PPM Inspections',
        'PPM Routine Maint': 'PPM Routine Maint',
        'Materials': 'Materials',
        'Preliminaries': 'Preliminaries'
    }
};

export default en;
